export class Colors {
  static Blue = '#1356A8'
  static DarkBlue = '#002A5B'
  static Black = '#111111'
  static White = '#FAFAFA'
  static Red = '#C60C31'
}
